import { useState, type FormEvent } from 'react';
import { annulClearance, ApiError } from '../api';
import { ANNULMENT_WARNING, annulmentRefusal } from './clearance-entry';

// Аннулирование записи допуска (issue #525).
//
// ЭТО НЕ УДАЛЕНИЕ, И КНОПКИ «УДАЛИТЬ» В ПАНЕЛИ НЕТ НИГДЕ. Запись остаётся в
// истории работника с ответом на вопросы «кто» и «почему»; она лишь перестаёт
// давать допуск. Удалённая запись отвечала бы на вопрос «а был ли вообще
// такой документ» молчанием.
//
// ПОДТВЕРЖДЕНИЕ, А НЕ «ВЫ УВЕРЕНЫ?». Человеку называют последствие и то, что
// оно необратимо, — и спрашивают причину. Причина обязательна: аннулирование
// без причины ничем не отличается от опечатки оператора, а разбираться по
// такой записи потом будет некому и не по чему.

export function ClearanceAnnulForm({
  clearanceId,
  typeName,
  documentNumber,
  issuedAt,
  token,
  organizationId,
  onDone,
  onCancel,
  onUnauthorized,
}: {
  clearanceId: string;
  typeName: string;
  documentNumber: string | null;
  /** Дата документа, уже человеческим видом: аннулируют конкретную бумагу. */
  issuedAt: string;
  token: string;
  organizationId: string;
  onDone: () => void;
  onCancel: () => void;
  onUnauthorized: () => void;
}) {
  const [reason, setReason] = useState('');
  const [serverRefusal, setServerRefusal] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const refusal = annulmentRefusal(reason);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (refusal !== null || busy) return;
    setBusy(true);
    setServerRefusal(null);
    try {
      await annulClearance(clearanceId, { reason: reason.trim() }, token, organizationId);
      onDone();
    } catch (error: unknown) {
      if (error instanceof ApiError && error.status === 401) onUnauthorized();
      // Текст сервера — как есть, по тому же доводу, что и в форме ввода.
      setServerRefusal(error instanceof Error ? error.message : 'Запись не аннулирована.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="clearance-entry clearance-annul" onSubmit={submit}>
      <h3 className="worker-card__title">Аннулирование: {typeName}</h3>
      <p className="section__note">
        {documentNumber ? `№ ${documentNumber} · ` : ''}от {issuedAt}
      </p>

      <p className="ui-error clearance-annul__warning">{ANNULMENT_WARNING}</p>

      <label className="clearance-entry__field">
        <span className="issue__label">Причина аннулирования</span>
        <textarea
          className="ui-input issue__area"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          disabled={busy}
        />
        <span className="issue__hint">Останется в истории допусков работника рядом с этой записью.</span>
      </label>

      {serverRefusal !== null ? <p className="ui-error">{serverRefusal}</p> : null}
      {refusal !== null ? <p className="section__note section__note--warn">{refusal}</p> : null}

      <div className="clearance-entry__actions">
        <button type="submit" className="ui-btn ui-btn--danger" disabled={refusal !== null || busy}>
          {busy ? 'Аннулирую…' : 'Аннулировать'}
        </button>
        <button type="button" className="ui-btn ui-btn--ghost" onClick={onCancel} disabled={busy}>
          Отмена
        </button>
      </div>
    </form>
  );
}
